// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1c-o";
export var animationRelative = "_1c-n";
export var backdropBlur = "_1c-0";
export var detailLabelCell = "_1c-10";
export var detailTable = "_1c-z";
export var detailValueCell = "_1c-11";
export var docIconBox = "_1c-19";
export var docTypeRow = "_1c-14";
export var docTypeRowInner = "_1c-15";
export var dropdownMatchDatePicker = "_1c-1";
export var fileUploadSpin = "_1c-h";
export var gorgiasOpenButton = "_1c-13 _1c-b";
export var gorgiasTicketCard = "_1c-12";
export var heroModalFooterButton = "_1c-16";
export var hiddenContainer = "_1c-m";
export var maxWidthContainer = "_1c-17";
export var modalContentBody = "_1c-8";
export var modalHeaderImage = "_1c-3";
export var modalImageLabel = "_1c-5";
export var modalImageOverlay = "_1c-4";
export var modalImageSubtitle = "_1c-7";
export var modalImageTitle = "_1c-6";
export var modalImageWrapper = "_1c-2";
export var modalStickyFooter = "_1c-9";
export var removeButton = "_1c-c";
export var sidebarColumn = "_1c-18";
export var spinner = "_1c-g";
export var timelineLine = "_1c-w";
export var timelineLineBlack = "_1c-y _1c-w";
export var timelineLineGray = "_1c-x _1c-w";
export var timelineLineHeight = "_1c-v";
export var tlDotActivate = "_1c-s";
export var tlDotActivateAnim = "_1c-r";
export var tlDotHide = "_1c-q";
export var tlDotHideAnim = "_1c-p";
export var tlLineActivate = "_1c-u";
export var tlLineActivateAnim = "_1c-t";
export var uploadHint = "_1c-l";
export var uploadIconBox = "_1c-i";
export var uploadLabel = "_1c-k";
export var uploadText = "_1c-j";
export var uploadZone = "_1c-d";
export var uploadZoneCursorDefault = "_1c-f";
export var uploadZoneCursorPointer = "_1c-e";
export var uploadedFileRow = "_1c-a";
export var viewButton = "_1c-b";